const videos = document.querySelectorAll('[data-video-id]');
if (videos) {
    for (const video of videos) {
        const {id, thumbnail, showUrl} = video.dataset;
        if (id) {
            const endpoint = 'https://www.googleapis.com/youtube/v3/videos';
            axios.get(endpoint, {
                params: {
                    key: googleKey,
                    part: 'snippet',
                    id
                }
            })
                .then((r) => {
                    const code = [];
                    if (r.data.items.length > 0) {
                        const tb = r.data.items[0].snippet.thumbnails.high;
                        code.push(`<a href="${showUrl}"><img src="${tb.url}" width="${tb.width}" height="${tb.height}" class="img-fluid"></a>`);
                    } else {
                        code.push(`<a href="${showUrl}"><img src="${thumbnail}" class="img-fluid"></a>`);
                    }
                    video.innerHTML = code.join('');
                })
                .catch((err) => {
                    console.log(err.response ? err.response : (err.request ? err.request : err));
                    const code = `<a href="${showUrl}"><img src="/images/no-thumbnail-default.png" width="640" height="480" class="img-fluid"></a>`;
                    video.innerHTML = code;
                });
        }
    }
}

// public 글쓰기 모드
const publicEditor = document.getElementById('editor-content');
if (publicEditor) {
    tinyMCE.init({
        selector: 'textarea#editor-content',
        menubar: false,
        language: 'ko_KR',
        plugins: 'print preview paste importcss searchreplace autolink autosave autoresize save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons',
        toolbar_sticky: true,
        toolbar: 'bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | forecolor backcolor removeformat | charmap emoticons link',
        autoresize_bottom_margin: 50,
        branding: false,
        min_height: 500,
        directionality: 'ltr'
    });

    if (editorContent.length > 0) {
        tinyMCE.activeEditor.setContent(editorContent);
    }
}

// 글 저장
const publicForm = document.getElementById('publicForm');
if (publicForm) {
    publicForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const f = e.target;
        const submitBtn = f.querySelector('button[type="submit"]');
        submitBtn.setAttribute('disabled', true);

        try {
            const fd = new FormData(e.target);
            fd.append('content', tinyMCE.activeEditor.getContent());

            const progress = e.target.querySelector('.progress');
            const bar = progress.querySelector('.progress-bar');

            progress.style.display = '';
            const r = await axios.post(f.action, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    bar.style.width = `${percentCompleted}%`;
                    bar.setAttribute('aria-valuenow', percentCompleted);
                }
            });

            const {redirectTo} = r.data;
            if ( redirectTo ) {
                location.href = redirectTo;
            }

        } catch (err) {
            console.log(err.response ?? err);
            submitBtn.removeAttribute('disabled');
            f.querySelector('.progress').style.display = 'none';

            if ( err.response && err.response.status === 422 ) {
                const {errors} = err.response.data;
                const keys = Object.keys(errors);
                for(let key of keys){
                    let item = f.querySelector('[name="attached[]"]');
                    if ( key === 'attached' ) {
                        item = f.querySelector(`[name="${key}"]`);
                    }

                    if ( item ) {
                        item.classList.add('is-invalid');
                        const feedback = item.closest('.form-group').querySelector('.invalid-feedback');
                        feedback.textContent = errors[key][0];
                    }
                }
            } else {
                alert("글 저장 중 오류 발생!\n관리자에게 문의바랍니다.");
            }
        }
    });
}


async function deleteAttachedFile(obj) {

    if ( !confirm('파일을 삭제할까요?') ) return false;

    try {
        const {userId, postId, attachedId} = obj.dataset;
        const r = axios.delete(`/api/attacheds/${attachedId}`, {
            params: {
                user_id: userId,
                post_id: postId
            }
        });

        obj.closest('li').remove();

    } catch ( err ) {
        console.log(err.response ?? err);
        if ( err.response && err.response.status === 422 ) {
            const {errors} = err.response.data;
            const message = [];
            for(let key of Object.keys(errors)) {
                const val = errors[key][0];
                message.push(val);
            }

            if ( message.length > 0 ) {
                alert(message.join("\n"));
            }
        }
        else if ( err.response && err.response.status === 403 ) {
            alert(err.response.data.message);
        }
    }
}
